import React, { useState, useEffect } from "react";
import { Fieldset } from "primereact/fieldset";
import { InputTextarea } from "primereact/inputtextarea";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import {
  appConstantes,
  limitSize,
  nemonicoEstadoDeshabilitar,
  nemonicoGruposCatalogos,
  nemonicoTipoSolicitud,
} from "../../constantes/appConstantes";
import { useSelector } from "react-redux";
import RenderToast from "../../componentes/RenderToast";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "primereact/button";
import { setCalendarLanguage } from "../../helpers/locale";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ModalTelefonos from "./ModalTelefonos";
import {
  gurdarDatosEntidad,
  obtenerDetalleEntidad,
  setMessageError,
  setMessageSuccess,
  setValidarDatos,
} from "../../sliceRedux/ValidarReserva.slice";
import moment from "moment";
import DownloadCroquis from "../../componentes/DownloadCroquis";
import Observation from "../../componentes/Observation";
import { CounterString } from "../../componentes/CounterString";

const EntidadConstitución = (props) => {
  const {
    showLoader,
    hideLoader,
    dispatch,
    stepperRef,
    datos,
    codSolReservaDenominacion,
    codSolConstitucion,
    setConstitucion,
    toast,
    nemTipoSolicitud,
  } = props;
  const listaPeriodos = useSelector((state) => state.validar.listaPeriodos);
  const validarDatos = useSelector((state) => state.validar.validarDatos);
  const messageSuccess = useSelector((state) => state.validar.messageSuccess);
  const messageError = useSelector((state) => state.validar.messageError);
  const [detalleEntidad, setDetalleEntidad] = useState({});
  const [modal, setModal] = useState(false);
  const [listaTelefonos, setListaTelefonos] = useState([]);
  const [deshabilitarCampos, setDeshabilitarCampos] = useState(false);
  setCalendarLanguage("es");

  useEffect(() => {
    showLoader();
    dispatch(obtenerDetalleEntidad(codSolReservaDenominacion, codSolConstitucion));
  }, []);

  useEffect(() => {
    if (validarDatos.code === 200) {
      setDetalleEntidad(validarDatos?.object?.solicitudReserva ?? {});
      setConstitucion(validarDatos?.object ?? {});
      formikEntidad.setFieldValue(
        "codSolConstitucion",
        validarDatos?.object?.codSolConstitucion ?? null
      );
      formikEntidad.setFieldValue("codSolReservaDenominacion", codSolReservaDenominacion);
      formikEntidad.setFieldValue("objetoSocial", validarDatos?.object?.objetoSocial ?? "");
      formikEntidad.setFieldValue(
        "codParamObjetoSocial",
        validarDatos?.object?.codParamObjetoSocial ?? null
      );
      formikEntidad.setFieldValue("vinculoComun", validarDatos?.object?.descVincComun ?? "");
      formikEntidad.setFieldValue(
        "documentoPersonalidadJuridica",
        validarDatos?.object?.codDocuPerJurid ?? ""
      );
      formikEntidad.setFieldValue(
        "fechaDocumento",
        validarDatos?.object?.fecDocumento
          ? moment(validarDatos?.object?.fecDocumento).toDate()
          : ""
      );
      formikEntidad.setFieldValue(
        "institucionPersonalidadJuridica",
        validarDatos?.object?.instPerJurid ?? ""
      );
      formikEntidad.setFieldValue(
        "fechaConvocatoria",
        validarDatos?.object?.fecConvotoria
          ? moment(validarDatos?.object?.fecConvotoria).toDate()
          : ""
      );
      formikEntidad.setFieldValue(
        "nemTipoSolicitud",
        validarDatos?.object?.nemTipoSolicitud ?? nemTipoSolicitud
      );
      formikEntidad.setFieldValue("barrio", validarDatos?.object?.barrioCiudadela ?? "");
      formikEntidad.setFieldValue("email", validarDatos?.object?.correo ?? "");
      formikEntidad.setFieldValue("capitalSocial", validarDatos?.object?.capitalSocial ?? null);
      formikEntidad.setFieldValue("socios", validarDatos?.object?.numSocios ?? null);
      formikEntidad.setFieldValue("periodo", validarDatos?.object?.codParamPeriodo ?? "");
      if (validarDatos?.object?.fecReunionAsamblea) {
        formikEntidad.setFieldValue(
          "fechaReunionAsamblea",
          validarDatos?.object?.fecReunionAsamblea
            ? moment(validarDatos?.object?.fecReunionAsamblea).toDate()
            : ""
        );
      }
      const estado =
        nemonicoEstadoDeshabilitar.includes(validarDatos?.object?.nemCatEstadoSolicitud) &&
        !validarDatos?.object?.observacion;
      setDeshabilitarCampos(estado);
      setListaTelefonos(validarDatos?.object?.listContacto ?? []);
    }
    return () => {
      hideLoader();
      dispatch(setValidarDatos({ ...validarDatos, code: 0 }));
    };
  }, [validarDatos.code]);

  useEffect(() => {
    if (messageSuccess != "") {
      RenderToast(toast, "success", "Éxito", messageSuccess);
      hideLoader();
    }
    return () => {
      dispatch(setMessageSuccess(""));
    };
  }, [messageSuccess]);

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
      hideLoader();
    }
    return () => {
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && <small className="p-error">{formikEntidad.errors[name]}</small>
    );
  };

  const validationSchemaEntidad = Yup.object().shape({
    fechaReunionAsamblea: Yup.string().required("Campo requerido."),
    vinculoComun: Yup.string().required("Campo requerido."),
    barrio: Yup.string().required("Campo requerido."),
    email: Yup.string()
      .email("Formato de correo electrónico no válido.")
      .required("Campo requerido."),
    socios: Yup.number().required("Campo requerido.").typeError("Campo requerido."),
    periodo: Yup.string().required("Campo requerido."),
    objetoSocial: Yup.string().required("Campo requerido."),
    capitalSocial: Yup.number()
      .required("Campo requerido.")
      .typeError("Campo requerido.")
      .test(
        "max-digits",
        "El valor debe tener como máximo 12 enteros y 2 decimales.",
        (value) => value == null || /^\d{1,12}(\.\d{1,2})?$/.test(String(value))
      ),
    documentoPersonalidadJuridica: Yup.string().when("nemTipoSolicitud", {
      is: nemonicoTipoSolicitud.ADECUACION,
      then: (schema) => schema.required("Campo requerido."),
      otherwise: (schema) => schema,
    }),
    fechaDocumento: Yup.string().when("nemTipoSolicitud", {
      is: nemonicoTipoSolicitud.ADECUACION,
      then: (schema) => schema.required("Campo requerido."),
      otherwise: (schema) => schema,
    }),
    institucionPersonalidadJuridica: Yup.string().when("nemTipoSolicitud", {
      is: nemonicoTipoSolicitud.ADECUACION,
      then: (schema) => schema.required("Campo requerido."),
      otherwise: (schema) => schema,
    }),
    fechaConvocatoria: Yup.string().when("nemTipoSolicitud", {
      is: nemonicoTipoSolicitud.ADECUACION,
      then: (schema) => schema.required("Campo requerido."),
      otherwise: (schema) => schema,
    }),
  });

  const formikEntidad = useFormik({
    initialValues: {
      fechaReunionAsamblea: "",
      barrio: "",
      email: "",
      socios: null,
      periodo: "",
      objetoSocial: "",
      capitalSocial: null,
      codSolConstitucion: codSolConstitucion,
      valorActivos: datos.valorActivos,
      vinculoComun: "",
      documentoPersonalidadJuridica: "",
      fechaDocumento: "",
      institucionPersonalidadJuridica: "",
      fechaConvocatoria: "",
      nemTipoSolicitud: nemTipoSolicitud,
    },
    validationSchema: validationSchemaEntidad,
    onSubmit: (data) => {
      const tieneCelular = listaTelefonos.some((telefono) => telefono.nemTipoContacto === nemonicoGruposCatalogos.TIPO_CELULAR);
      if (!tieneCelular) {
        RenderToast(
          toast,
          "warn",
          "Información",
          "Debe registrar al menos un número de teléfono Celular."
        );
      } else {
        showLoader();
        let dataSend = {
          codSolicitudConstitucion: data.codSolConstitucion,
          codReserva: data.codSolReservaDenominacion,
          codTipoSolicitud: datos?.idTipoSolicitud ?? null,
          codGrupoConstAdec: datos?.tipoEntidad ?? null,
          barrioCiudadela: data.barrio,
          correo: data.email,
          codParamObjetoSocial: data.codParamObjetoSocial,
          fechaAsamblea: moment(data.fechaReunionAsamblea, "DD/MM/YYYY").valueOf(),
          numSocios: data.socios,
          codParamPeriodo: data.periodo,
          capitalSocial: data.capitalSocial,
          valorActivo: data.valorActivos,
          ruc: datos?.ruc ?? null,
          descVincComun: data.vinculoComun,
          codDocuPerJurid: data.documentoPersonalidadJuridica,
          fecDocumento: moment(data.fechaDocumento, "DD/MM/YYYY").valueOf(),
          instPerJurid: data.institucionPersonalidadJuridica,
          fecConvotoria: moment(data.fechaConvocatoria, "DD/MM/YYYY").valueOf(),
          listContacto: listaTelefonos,
        };
        dispatch(gurdarDatosEntidad(dataSend));
      }
    },
  });

  const isFormFieldValid = (name) => {
    const isValid = !!(formikEntidad.touched[name] && formikEntidad.errors[name]);
    return isValid;
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const rowIndexTemplate = (rowData, column) => {
    return column.rowIndex + 1 + "";
  };

  const onSaveTelefono = (data) => {
    const existe = listaTelefonos.some(
      (telefono) => telefono.contacto === data.contacto && telefono.codTipo === data.codTipo
    );

    if (existe) {
      RenderToast(
        toast,
        "warn",
        "Información",
        "El número de teléfono ya existe con el mismo tipo."
      );
    } else {
      toggleModal();
      let nLista = [...listaTelefonos];
      nLista.push(data);
      setListaTelefonos(nLista);
    }
  };

  const actionTemplate = (rowData, e) => {
    return (
      <>
        <Button
          icon="pi pi-trash"
          rounded
          className="mr-2"
          tooltip="Eliminar"
          severity="danger"
          text
          disabled={deshabilitarCampos}
          tooltipOptions={{ position: "top" }}
          onClick={() => {
            let nLista = [...listaTelefonos];
            nLista.splice(e.rowIndex, 1);
            setListaTelefonos(nLista);
          }}
        />
      </>
    );
  };
  return (
    <>
      <div className="card">
        <Observation observationValue={validarDatos?.object?.observacion} />
        <Fieldset legend="Datos de la entidad">
          <div className="grid">
            <div className="col-12 md:col-12">
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="codigoReserva"
                  className="mr-2"
                  style={{ minWidth: "150px", textAlign: "left" }}
                  required
                >
                  Número solicitud de reserva:
                </label>
                <div className="col">
                  <InputText
                    id="codigoReserva"
                    name="codigoReserva"
                    value={detalleEntidad.numSolicitud ?? ""}
                    autoComplete="off"
                    disabled
                    className={classNames({
                      "p-invalid": isFormFieldValid("codigoReserva"),
                    })}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("codigoReserva")}
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="razonSocial"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Razón social:
                </label>
                <div className="col">
                  <InputText
                    id="razonSocial"
                    name="razonSocial"
                    value={
                      (detalleEntidad.nomCatTipoCaja ?? "").toUpperCase() +
                      " " +
                      (detalleEntidad.nomParticular ?? "").toUpperCase()
                    }
                    autoComplete="off"
                    disabled
                    className={classNames({
                      "p-invalid": isFormFieldValid("razonSocial"),
                    })}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("razonSocial")}
                </div>
              </div>
            </div>
            <div className="col-12 md:col-6">
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="tipoCaja"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Tipo de caja:
                </label>
                <div className="col">
                  <InputText
                    id="tipoCaja"
                    name="tipoCaja"
                    value={detalleEntidad.nomCatTipoCaja ?? ""}
                    autoComplete="off"
                    disabled
                    className={classNames({
                      "p-invalid": isFormFieldValid("tipoCaja"),
                    })}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("tipoCaja")}
                </div>
              </div>

              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="provincia"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Provincia:
                </label>
                <div className="col">
                  <InputText
                    id="provincia"
                    name="provincia"
                    value={detalleEntidad.nomAmbGeoProvincia ?? ""}
                    disabled
                    className={classNames({
                      "p-invalid": isFormFieldValid("provincia"),
                    })}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("provincia")}
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="canton"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Cantón:
                </label>
                <div className="col">
                  <InputText
                    id="canton"
                    name="canton"
                    value={detalleEntidad.nomAmbGeoCanton ?? ""}
                    disabled
                    className={classNames({
                      "p-invalid": isFormFieldValid("canton"),
                    })}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("canton")}
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="parroquia"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Parroquia:
                </label>
                <div className="col">
                  <InputText
                    id="parroquia"
                    name="parroquia"
                    value={detalleEntidad.nomAmbGeoParroquia ?? ""}
                    disabled
                    className={classNames({
                      "p-invalid": isFormFieldValid("parroquia"),
                    })}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("parroquia")}
                </div>
              </div>

              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="barrio"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Barrio / Ciudadela:
                </label>
                <div className="col">
                  <InputText
                    id="barrio"
                    name="barrio"
                    value={formikEntidad.values.barrio}
                    autoComplete="off"
                    className={classNames({
                      "p-invalid": isFormFieldValid("barrio"),
                    })}
                    disabled={deshabilitarCampos}
                    maxLength={limitSize.TEXT_INPUT}
                    onChange={(e) => {
                      formikEntidad.handleChange(e);
                    }}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("barrio")}
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="email"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Correo electrónico:
                </label>
                <div className="col">
                  <InputText
                    id="email"
                    name="email"
                    value={formikEntidad.values.email}
                    autoComplete="off"
                    disabled={deshabilitarCampos}
                    className={classNames({
                      "p-invalid": isFormFieldValid("email"),
                    })}
                    onChange={(e) => {
                      formikEntidad.handleChange(e);
                    }}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("email")}
                </div>
              </div>

              <Button
                type="button"
                icon="pi pi-phone"
                iconPos="right"
                label="Agregar"
                disabled={deshabilitarCampos}
                severity="secondary"
                className="mb-2"
                onClick={toggleModal}
              />

              <DataTable
                value={listaTelefonos}
                emptyMessage={appConstantes.SIN_DATOS}
                paginator
                rows={3}
              >
                <Column
                  body={rowIndexTemplate}
                  header="Nro."
                  headerStyle={{ textAlign: "center" }}
                  style={{ width: "3%" }}
                  bodyStyle={{
                    textAlign: "center",
                  }}
                />
                <Column field="nomTipoContacto" header="Tipo" sortable />
                <Column field="contacto" header="Número" sortable />
                <Column
                  header="Acciones"
                  headerStyle={{ textAlign: "center" }}
                  bodyStyle={{
                    textAlign: "center",
                  }}
                  body={actionTemplate}
                ></Column>
              </DataTable>
            </div>
            <div className="col-12 md:col-6">
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="tipoVinculo"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                  required
                >
                  Tipo de vínculo común:
                </label>
                <div className="col">
                  <InputText
                    id="tipoVinculo"
                    name="tipoVinculo"
                    value={detalleEntidad.nomVinculoComun ?? ""}
                    autoComplete="off"
                    disabled
                    className={classNames({
                      "p-invalid": isFormFieldValid("tipoVinculo"),
                    })}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="vinculoComun"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                  required
                >
                  Vínculo común:
                </label>
                <div className="col">
                  <InputTextarea
                    id="vinculoComun"
                    name="vinculoComun"
                    value={formikEntidad.values.vinculoComun}
                    onChange={formikEntidad.handleChange}
                    autoComplete="off"
                    rows={3}
                    maxLength={limitSize.TEXT_INPUT_1000}
                    className={classNames({
                      "p-invalid": isFormFieldValid("vinculoComun"),
                    })}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("vinculoComun")}
                  <CounterString
                    length={formikEntidad.values.vinculoComun.length}
                    maxLength={limitSize.TEXT_INPUT_1000}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="callePrincipal"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                  required
                >
                  Calle principal:
                </label>
                <div className="col">
                  <InputTextarea
                    id="callePrincipal"
                    name="callePrincipal"
                    value={detalleEntidad.nomCallePrincipal ?? ""}
                    autoComplete="off"
                    rows={2}
                    disabled
                    maxLength={limitSize.TEXT_INPUT}
                    className={classNames({
                      "p-invalid": isFormFieldValid("callePrincipal"),
                    })}
                    onChange={formikEntidad.handleChange}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="calleSecundaria"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                  required
                >
                  Calle secundaria:
                </label>
                <div className="col">
                  <InputTextarea
                    id="calleSecundaria"
                    name="calleSecundaria"
                    value={detalleEntidad.nomCalleSecundaria ?? ""}
                    autoComplete="off"
                    rows={2}
                    disabled
                    maxLength={limitSize.TEXT_INPUT}
                    className={classNames({
                      "p-invalid": isFormFieldValid("calleSecundaria"),
                    })}
                    onChange={formikEntidad.handleChange}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-8">
                <label
                  htmlFor="numero"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                >
                  Número:
                </label>
                <div className="col">
                  <InputText
                    id="numero"
                    name="numero"
                    value={detalleEntidad.txtNumero ?? ""}
                    autoComplete="off"
                    disabled
                    maxLength={limitSize.TEXT_INPUT_NUMBER}
                    className={classNames({
                      "p-invalid": isFormFieldValid("numero"),
                    })}
                    onChange={formikEntidad.handleChange}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("numero")}
                </div>
              </div>
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="parroquia"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                >
                  Referencia:
                </label>
                <div className="col">
                  <InputTextarea
                    id="referencia"
                    name="referencia"
                    rows={3}
                    disabled
                    maxLength={limitSize.TEXT_AREA}
                    value={detalleEntidad.txtReferencia ?? ""}
                    autoComplete="off"
                    className={classNames({
                      "p-invalid": isFormFieldValid("referencia"),
                    })}
                    onChange={formikEntidad.handleChange}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("referencia")}
                </div>
              </div>
              <DownloadCroquis
                showLoader={showLoader}
                hideLoader={hideLoader}
                codSolicitud={codSolReservaDenominacion}
                dispatch={dispatch}
                toast={toast}
              />
            </div>
          </div>
        </Fieldset>
        <div className="m-3"></div>
        <Fieldset legend="Datos asamblea constitutiva">
          <div className="grid">
            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="fechaReunionAsamblea"
                className="mr-2"
                style={{ minWidth: "150px", textAlign: "left" }}
                required
              >
                Fecha reunión asamblea:
              </label>
              <div className="col">
                <Calendar
                  id="fechaReunionAsamblea"
                  name="fechaReunionAsamblea"
                  value={formikEntidad.values.fechaReunionAsamblea}
                  onChange={formikEntidad.handleChange}
                  dateFormat="dd/mm/yy"
                  className={classNames({
                    "p-invalid": isFormFieldValid("fechaReunionAsamblea"),
                  })}
                  disabled={deshabilitarCampos}
                  showIcon
                  maxDate={new Date()}
                  style={{ width: "100%" }}
                  locale="es"
                />
                {getFormErrorMessage("fechaReunionAsamblea")}
              </div>
            </div>
            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="socios"
                className="mr-2"
                style={{ minWidth: "120px", textAlign: "left" }}
                required
              >
                Número de socios:
              </label>
              <div className="col">
                <InputNumber
                  id="socios"
                  name="socios"
                  value={formikEntidad.values.socios}
                  autoComplete="off"
                  maxFractionDigits={0}
                  useGrouping={false}
                  className={classNames({
                    "p-invalid": isFormFieldValid("socios"),
                  })}
                  disabled={deshabilitarCampos}
                  onValueChange={(e) => {
                    formikEntidad.handleChange(e);
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("socios")}
              </div>
            </div>
            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="periodo"
                className="mr-2"
                style={{ minWidth: "150px", textAlign: "left" }}
                required
              >
                Período representantes:
              </label>
              <div className="col">
                <Dropdown
                  id="periodo"
                  name="periodo"
                  value={formikEntidad.values.periodo}
                  options={listaPeriodos?.object ?? []}
                  optionLabel="numValor"
                  optionValue="codParamPro"
                  autoComplete="off"
                  disabled={deshabilitarCampos}
                  className={classNames({
                    "p-invalid": isFormFieldValid("periodo"),
                  })}
                  onChange={(e) => {
                    formikEntidad.handleChange(e);
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("periodo")}
              </div>
            </div>
          </div>
        </Fieldset>
        <div className="m-3"></div>
        <Fieldset legend="Datos adicionales">
          <div className="grid">
            <div className="flex col-12 md:col-8 ">
              <label
                htmlFor="capitalSocial"
                className="mr-2"
                style={{ minWidth: "140px", textAlign: "left" }}
                required
              >
                Objeto social:
              </label>
              <div className="col">
                <InputTextarea
                  id="objetoSocial"
                  name="objetoSocial"
                  value={formikEntidad.values.objetoSocial}
                  autoComplete="off"
                  rows={2}
                  className={classNames({
                    "p-invalid": isFormFieldValid("objetoSocial"),
                  })}
                  onChange={(e) => {
                    formikEntidad.handleChange(e);
                  }}
                  disabled
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("objetoSocial")}
              </div>
            </div>
            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="capitalSocial"
                className="mr-2"
                style={{ minWidth: "140px", textAlign: "left" }}
                required
              >
                Capital social inicial:
              </label>
              <div className="col">
                <InputNumber
                  id="capitalSocial"
                  name="capitalSocial"
                  value={formikEntidad.values.capitalSocial}
                  autoComplete="off"
                  useGrouping={false}
                  maxFractionDigits={2}
                  minFractionDigits={2}
                  min={0}
                  disabled={deshabilitarCampos}
                  className={classNames({
                    "p-invalid": isFormFieldValid("capitalSocial"),
                  })}
                  onValueChange={(e) => {
                    formikEntidad.handleChange(e);
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("capitalSocial")}
              </div>
            </div>

            {formikEntidad.values.nemTipoSolicitud === nemonicoTipoSolicitud.ADECUACION && (
              <>
                <div className="col-12 md:col-8 ">
                  <label htmlFor="documentoPersonalidadJuridica" required>
                    Código de documento que otorgó personalidad jurídica:
                  </label>
                  <div className="col">
                    <InputTextarea
                      id="documentoPersonalidadJuridica"
                      name="documentoPersonalidadJuridica"
                      value={formikEntidad.values.documentoPersonalidadJuridica}
                      autoComplete="off"
                      rows={2}
                      className={classNames({
                        "p-invalid": isFormFieldValid("documentoPersonalidadJuridica"),
                      })}
                      maxLength={limitSize.TEXT_INPUT}
                      onChange={(e) =>
                        formikEntidad.setFieldValue(
                          "documentoPersonalidadJuridica",
                          e.target.value.toUpperCase()
                        )
                      }
                      style={{ width: "100%" }}
                    />
                    {getFormErrorMessage("documentoPersonalidadJuridica")}
                    <CounterString
                      length={formikEntidad.values.documentoPersonalidadJuridica.length}
                      maxLength={limitSize.TEXT_INPUT}
                    />
                  </div>
                </div>
                <div className="col-12 md:col-3 ">
                  <label htmlFor="fechaDocumento" required>
                    Fecha de documento:
                  </label>
                  <div className="col">
                    <Calendar
                      id="fechaDocumento"
                      name="fechaDocumento"
                      value={formikEntidad.values.fechaDocumento}
                      onChange={formikEntidad.handleChange}
                      maxDate={new Date()}
                      dateFormat="dd/mm/yy"
                      className={classNames({
                        "p-invalid": isFormFieldValid("fechaDocumento"),
                      })}
                      showIcon
                      style={{ width: "100%" }}
                    />
                    {getFormErrorMessage("fechaDocumento")}
                  </div>
                </div>
                <div className="col-12 md:col-8 ">
                  <label htmlFor="institucionPersonalidadJuridica" required>
                    Institución que otorgó personalidad jurídica:
                  </label>
                  <div className="col">
                    <InputTextarea
                      id="institucionPersonalidadJuridica"
                      name="institucionPersonalidadJuridica"
                      value={formikEntidad.values.institucionPersonalidadJuridica}
                      autoComplete="off"
                      rows={2}
                      className={classNames({
                        "p-invalid": isFormFieldValid("institucionPersonalidadJuridica"),
                      })}
                      maxLength={limitSize.TEXT_INPUT_300}
                      onChange={(e) =>
                        formikEntidad.setFieldValue(
                          "institucionPersonalidadJuridica",
                          e.target.value.toUpperCase()
                        )
                      }
                      style={{ width: "100%" }}
                    />
                    {getFormErrorMessage("institucionPersonalidadJuridica")}
                    <CounterString
                      length={formikEntidad.values.institucionPersonalidadJuridica.length}
                      maxLength={limitSize.TEXT_INPUT_300}
                    />
                  </div>
                </div>
                <div className="col-12 md:col-3 ">
                  <label htmlFor="fechaDocumento" className="mr-2" required>
                    Fecha de convocatoria a asamblea de órgano de gobierno:
                  </label>
                  <div className="col">
                    <Calendar
                      id="fechaConvocatoria"
                      name="fechaConvocatoria"
                      value={formikEntidad.values.fechaConvocatoria}
                      onChange={formikEntidad.handleChange}
                      maxDate={new Date()}
                      dateFormat="dd/mm/yy"
                      className={classNames({
                        "p-invalid": isFormFieldValid("fechaConvocatoria"),
                      })}
                      showIcon
                      style={{ width: "100%" }}
                    />
                    {getFormErrorMessage("fechaConvocatoria")}
                  </div>
                </div>
              </>
            )}
          </div>
        </Fieldset>
        <div className="flex pt-4 justify-content-between">
          <Button
            type="button"
            label="Guardar"
            onClick={formikEntidad.handleSubmit}
            disabled={deshabilitarCampos}
            icon="pi pi-save"
            className="mr-2"
          />
          <Button
            label="Continuar"
            severity="warning"
            type="button"
            icon="pi pi-arrow-right"
            iconPos="right"
            disabled={!validarDatos?.object?.codSolConstitucion}
            onClick={() => stepperRef.current.nextCallback()}
          />
        </div>
      </div>
      {modal && (
        <ModalTelefonos
          modal={modal}
          callbackModal={toggleModal}
          showLoader={showLoader}
          hideLoader={hideLoader}
          dispatch={dispatch}
          callbackSave={onSaveTelefono}
        />
      )}
    </>
  );
};
export default EntidadConstitución;
